import React from 'react';

const Destinations1 = () => {
  return (
    <div>
    <div className="container">
            <div className="ktm_left">
                <h2>The Kathmandu City</h2>
                <p> City of Temples</p>
                <img src="img/bhaktapur.jpg" alt="ktm" />
            </div>
            <div className="ktm_center">Kathmandu is particularly famous for its religious monuments. Various temples,
                monasteries, and stupas adorn the city's landscape, particularly the Pashupatinath Temple and the Changu
                Narayan which are famous for their stunning, intricate religious artworks.
                Manju-Patan
                It was founded in 723 by Raja Gunakamadeva. Its early name was Manju-Patan; the present name refers to a
                wooden temple (kath, “wood”; mandir, “temple” or “edifice”) said to have been built from the wood of a
                single tree by Raja Lachmina Singh in 1596.</div>

            <div className="ktm_right">
                <h3>Nearby Places</h3>
                <div className="img1">
                    <div className="row1">
                        <img src="img/Kakani.jpg" alt="kakani"/>
                        <h4>Kakani</h4>
                    </div>
                    <div className="row2">
                        <img src="img/nagarkot.jpg" alt="nagarkot"/>
                        <h4>Nagarkot</h4>
                    </div>
                </div>

                <div className="img2">
                    <div className="row3">
                        <img src="img/bhaktapur.jpg" alt="bhaktapur"/>
                        <h4>Bhaktapur</h4>
                    </div>
                    <div className="row4">
                        <img src="img/chisapani.jpg" alt="chisapani"/>
                        <h4>Chisapani</h4>
                    </div>
                </div>
            </div>
        </div>

        

<div className="container">
    <div className="ktm_left">
        <h2>The Pokhara City</h2>
        <p> City of Nature</p>
        <img src="img/pokhara.jpg" alt="ktm" />
    </div>
    <div className="ktm_center">
        Pokhara | Jewel in the Himalaya | Nepal Tourism Board
        The Pokhara is best known for the stunning view of the Annapurna range. It is perhaps one of the few places on earth from where mountains above 6,000 m can be seen unobstructed from an altitude of 800 m within the distance of 28 km.Boating in Phewa Taal, Witness Sunrise at Sarangkot, Visit Devi's Fall, Marvel at Shanti Stupa, Seek blessings at Bindhyabasini Temple,River Rafting, Check Out the International Mountain Museum, Pray at Barahi Temple, Explore Gupteshwor Mahadev Cave, and many more.
    </div>

    <div className="ktm_right">
        <h3>Nearby Places</h3>
        <div className="img1">
            <div className="row1">
                <img src="img/khumai.jpg_large" alt="khumai" />
                <h4>Khumai</h4>
            </div>
            <div className="row2">
                <img src="img/Begnas.jpg" alt="begnas" /> 
                <h4>Begnas Taal</h4>
            </div>
        </div>

        <div className="img2">
            <div className="row3">
                <img src="img/rupa.jpg" alt="rupa" />
                <h4>Rupa Taal</h4>
            </div>
            <div className="row4">
                <img src="img/mardi.jpg" alt="mardi" />
                <h4>Mardi</h4>
            </div>
        </div>
    </div>
</div>


<div className="container">
    <div className="ktm_left">
        <h2>The Chitwan City</h2>
        <p> City of Beautiful Creatures</p>
        <img src="img/chitwan.jpg" alt="chitwan" />
    </div>
    <div className="ktm_center">The main attraction in Chitwan and the reason everyone goes is for Chitwan National Safari Park. It's very large and provides opportunities for seeing animals including leopards, elephants etc. One of the activities you can undertake in the park are walks.Chitwan National Park is designated as a UNESCO natural heritage site. Evidently, the park alone houses 128 Royal Bengal Tigers according to a national survey in 2022. For the same reason, it is the largest playground for tigers in Nepal.</div>

    <div className="ktm_right">
        <h3>Nearby Places</h3>
        <div className="img1">
            <div className="row1">
                <img src="img/cnp.jpg" alt="cnp" />
                <h4>Chitwan National Park</h4>
            </div>
            <div className="row2">
                <img src="img/devghat.jpg" alt="devghat" />
                <h4>Devghat</h4>
            </div>
        </div>

        <div className="img2">
            <div className="row3">
                <img src="img/cg.jpg" alt="cg" />
                <h4>CG Temple</h4>
            </div>
            <div className="row4">
                <img src="img/Bishazari.webp" alt="bishazari" />
                <h4>Bishazari Taal</h4>
            </div>
        </div>
    </div>
</div>


    <div className="container">
        <div className="ktm_left">
            <h2>Lumbini</h2>
            <p> City of Gautam Buddha</p>
            <img src="img/Mayadevi.jpg" alt="Lumbini" />
        </div>
        <div className="ktm_center">Siddhartha Gautama, the Lord Buddha, was born in 623 B.C. in the famous gardens of Lumbini, which soon became a place of pilgrimage. Among the pilgrims was the Indian emperor Ashoka, who erected one of his commemorative inscribed Ashoka pillars there. The inscription on the pillar is the oldest in Nepal.You can take flight from Kathmandu to Siddhartha Nagar which is 22 km away from Lumbini. From there, you can take buses. If travelling by bus from Kathmandu, Pokhara, Gorakhpur and Varanasi , you can come to Sunauli which is around 30 km from Lumbini.</div>

        <div className="ktm_right">
            <h3>Nearby Places</h3>
            <div className="img1">
                <div className="row1">
                    <img src="img/Peace_pagoda.jpg" alt="kakani" />
                    <h4>World Peace Pagoda</h4>
                </div>
                <div className="row2">
                    <img src="img/Lumbini.jpg" alt="nagarkot" />
                    <h4>Lumbini Museum</h4>
                </div>
            </div>

            <div className="img2">
                <div className="row3">
                    <img src="img/Golden_temple.jpg" alt="bhaktapur" />
                    <h4>Golden Temple</h4>
                </div>
                <div className="row4">
                    <img src="img/bodh.jpg" alt="chisapani" />
                    <h4>Bodhi Tree</h4>
                </div>
            </div>
        </div>
    </div>



        <div className="container">
            <div className="ktm_left">
                <h2>Janakpur</h2>
                <p> City of Temples</p>
                <img src="img/janakpur.jpg" alt="ktm" />
            </div>
            <div className="ktm_center">Janakpur is an important pilgrimage site for Hindus due to its connection with the Hindu epic, the Ramayana. It is believed that Goddess Sita was born here and it is the place of her marriage with Lord Ram.During the Treta Yug/ period about 12,000 years ago Janakpur used to be the capital of King Janak's Kingdom of Mithila. Known as the capital of Province 2 today, Janakpur the birthplace of Janaki or Sita, the consort of Lord Ram, is an important religious pilgrimage site in the Terai plains, in south central Nepal.</div>

            <div className="ktm_right">
                <h3>Nearby Places</h3>
                <div className="img1">
                    <div className="row1">
                        <img src="img/jaleshwor.jpg" alt="Jaleshwor" />
                        <h4>Jaleshwor</h4>
                    </div>
                    <div className="row2">
                        <img src="img/rolwaling.jpg" alt="Rolwaling Valley" />
                        <h4>Rolwaling Valley</h4>
                    </div>
                </div>

                <div className="img2">
                    <div className="row3">
                        <img src="img/ram.jpg" alt="Ram Sita Mandap" />
                        <h4>Ram Sita Mandap</h4>
                    </div>
                    <div className="row4">
                        <img src="img/ganga.jpg" alt="Ganga Sakar" />
                        <h4>Ganga Sakar</h4>
                    </div>
                </div>
            </div>
        </div>
        </div>
  )
}

export default Destinations1